
export const getTheme = (config: any) => {
    if (config?.property_code === 'LC') {
        return {
            "breakpoints": {
                "keys": ["xs", "sm", "md", "lg", "xl"],
                "values": { "xs": 0, "sm": 576, "md": 960, "lg": 1280, "xl": 1600 }
            },
            palette: {
                primary: {
                    "light": "#a271a5",
                    "main": "#543C56",
                    "contrastText": "#FFFFFF"
                },
                secondary: {
                    "light": "#7FBFA0",
                    "main": "#A2CCA0",
                    "contrastText": "#FFFFFF"
                },
                text: {
                    primary: "#FFFFFF",
                    secondary: "#000000",
                    disabled: "#919191",
                    hint: ""
                },
                grey: {
                    50: "#fafafa",
                    100: "#f5f5f5",
                    200: "#eeeeee",
                    300: "#e0e0e0",
                    400: "#bdbdbd",
                    500: "#9e9e9e",
                    600: "#757575",
                    700: "#616161",
                    800: "#424242",
                    900: "#212121",
                }
            },
            "typography": {
                "htmlFontSize": 16,
                fontWeightLight: 300,
                fontWeightRegular: 400,
                fontWeightMedium: 500,
                fontWeightBold: 700,
                "h1": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#543C56",
                    "font-size": "2.5rem",
                    "font-weight": 700,
                },
                "h2": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "32px",
                    "font-weight": 700,
                },
                "h3": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "28px",
                    "font-weight": 700,
                },
                "h4": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "24px",
                    "font-weight": 700,
                },
                "h5": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "20px",
                    "font-weight": 500,
                },
                "h6": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "16px",
                    "font-weight": 500,
                },
                "subtitle1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "subtitle2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif"
                },
                "button": {
                    "font-size": "14px",
                    "font-weight": 600,
                    "letter-spacing": "0.42px",
                    "font-family": "Maven Pro, sans-serif",
                },
                "caption": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "0.36px"
                },
                "overline": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "1.8px"
                }
            }
        };
    }
    if (config?.property_code === 'PF') {
        return {
            "breakpoints": {
                "keys": ["xs", "sm", "md", "lg", "xl"],
                "values": { "xs": 0, "sm": 576, "md": 960, "lg": 1280, "xl": 1600 }
            },
            palette: {
                primary: {
                    "light": "#1baff2",
                    "main": "#3288f0",
                    "contrastText": "#FFFFFF"
                },
                secondary: {
                    "light": "#b272b3",
                    "main": "#a5378b",
                    "contrastText": "#FFFFFF"
                },
                text: {
                    primary: "#FFFFFF",
                    secondary: "#000000",
                    disabled: "#919191",
                    hint: ""
                },
                grey: {
                    50: "#fafafa",
                    100: "#f5f5f5",
                    200: "#eeeeee",
                    300: "#e0e0e0",
                    400: "#bdbdbd",
                    500: "#9e9e9e",
                    600: "#757575",
                    700: "#616161",
                    800: "#424242",
                    900: "#212121",
                }
            },
            "typography": {
                "htmlFontSize": 16,
                fontWeightLight: 300,
                fontWeightRegular: 400,
                fontWeightMedium: 500,
                fontWeightBold: 700,
                "h1": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#3288f0",
                    "font-size": "2.5rem",
                    "font-weight": 700,
                },
                "h2": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "32px",
                    "font-weight": 700,
                },
                "h3": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "28px",
                    "font-weight": 700,
                },
                "h4": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "24px",
                    "font-weight": 700,
                },
                "h5": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "20px",
                    "font-weight": 500,
                },
                "h6": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "16px",
                    "font-weight": 500,
                },
                "subtitle1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "subtitle2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif"
                },
                "button": {
                    "font-size": "14px",
                    "font-weight": 600,
                    "letter-spacing": "0.42px",
                    "font-family": "Maven Pro, sans-serif",
                },
                "caption": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "0.36px"
                },
                "overline": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "1.8px"
                }
            }
        };
    }
    if (config?.property_code === 'VP') {
        return {
            "breakpoints": {
                "keys": ["xs", "sm", "md", "lg", "xl"],
                "values": { "xs": 0, "sm": 576, "md": 960, "lg": 1280, "xl": 1600 }
            },
            palette: {
                primary: {
                    "light": "#b6b2a3",
                    "main": "#848077",
                    "contrastText": "#FFFFFF"
                },
                secondary: {
                    "light": "#e9fac8",
                    "main": "#ddb972",
                    "dark": "#8c7446",
                    "contrastText": "#000000"
                },
                text: {
                    primary: "#FFFFFF",
                    secondary: "#000000",
                    disabled: "#919191",
                    hint: ""
                },
                grey: {
                    50: "#fafafa",
                    100: "#f5f5f5",
                    200: "#eeeeee",
                    300: "#e0e0e0",
                    400: "#bdbdbd",
                    500: "#9e9e9e",
                    600: "#757575",
                    700: "#616161",
                    800: "#424242",
                    900: "#212121",
                }
            },
            "typography": {
                "htmlFontSize": 16,
                fontWeightLight: 300,
                fontWeightRegular: 400,
                fontWeightMedium: 500,
                fontWeightBold: 700,
                "h1": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#ddb972",
                    "font-size": "2.5rem",
                    "font-weight": 700,
                },
                "h2": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "32px",
                    "font-weight": 700,
                },
                "h3": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "28px",
                    "font-weight": 700,
                },
                "h4": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "24px",
                    "font-weight": 700,
                },
                "h5": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "20px",
                    "font-weight": 500,
                },
                "h6": {
                    "font-family": "Maven Pro, sans-serif",
                    "color": "#1D1D1D",
                    "font-size": "16px",
                    "font-weight": 500,
                },
                "subtitle1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "subtitle2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body1": {
                    "font-size": "16px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif",
                },
                "body2": {
                    "font-size": "14px",
                    "font-weight": 400,
                    "font-family": "Roboto, sans-serif"
                },
                "button": {
                    "font-size": "14px",
                    "font-weight": 600,
                    "letter-spacing": "0.42px",
                    "font-family": "Maven Pro, sans-serif",
                },
                "caption": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "0.36px"
                },
                "overline": {
                    "font-size": "12px",
                    "font-weight": 500,
                    "letter-spacing": "1.8px"
                }
            }
        };
    }
    return {
        "breakpoints": {
            "keys": ["xs", "sm", "md", "lg", "xl"],
            "values": { "xs": 0, "sm": 576, "md": 960, "lg": 1280, "xl": 1600 }
        },
        palette: {
            primary: {
                "light": "#ece57d",
                "main": "#97DDCC",
                "dark": "#d7c81b",
                "contrastText": "#FFFFFF"
            },
            secondary: {
                "light": "#c4f6e2",
                "main": "#97DDCC",
                "dark": "#65a19d",
                "contrastText": "#1D1D1D"
            },
            text: {
                primary: "#97DDCC",
                secondary: "#97DDCC",
                disabled: "#919191",
                hint: ""
            },
            grey: {
                50: "#fafafa",
                100: "#f5f5f5",
                200: "#eeeeee",
                300: "#e0e0e0",
                400: "#bdbdbd",
                500: "#9e9e9e",
                600: "#757575",
                700: "#616161",
                800: "#424242",
                900: "#212121",
            }
        },
        "typography": {
            "htmlFontSize": 16,
            fontWeightLight: 300,
            fontWeightRegular: 400,
            fontWeightMedium: 500,
            fontWeightBold: 700,
            "h1": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#97DDCC",
                "font-size": "2.5rem",
                "font-weight": 700,
            },
            "h2": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#1D1D1D",
                "font-size": "32px",
                "font-weight": 700,
            },
            "h3": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#1D1D1D",
                "font-size": "28px",
                "font-weight": 700,
            },
            "h4": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#1D1D1D",
                "font-size": "24px",
                "font-weight": 700,
            },
            "h5": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#1D1D1D",
                "font-size": "20px",
                "font-weight": 500,
            },
            "h6": {
                "font-family": "Maven Pro, sans-serif",
                "color": "#1D1D1D",
                "font-size": "16px",
                "font-weight": 500,
            },
            "subtitle1": {
                "font-size": "16px",
                "font-weight": 400,
                "font-family": "Roboto, sans-serif",
            },
            "subtitle2": {
                "font-size": "14px",
                "font-weight": 400,
                "font-family": "Roboto, sans-serif",
            },
            "body1": {
                "font-size": "16px",
                "font-weight": 400,
                "font-family": "Roboto, sans-serif",
            },
            "body2": {
                "font-size": "14px",
                "font-weight": 400,
                "font-family": "Roboto, sans-serif"
            },
            "button": {
                "font-size": "14px",
                "font-weight": 600,
                "letter-spacing": "0.42px",
                "font-family": "Maven Pro, sans-serif",
            },
            "caption": {
                "font-size": "12px",
                "font-weight": 500,
                "letter-spacing": "0.36px"
            },
            "overline": {
                "font-size": "12px",
                "font-weight": 500,
                "letter-spacing": "1.8px"
            }
        },
        overrides: {
            MuiButtonBase: {
                root: {
                    borderRadius: '0!important'
                }
            },
            MuiInput: {
                underline: {
                    '&:hover': {
                        '&:not(.Mui-disabled):before': {
                            borderBottom: '2px solid #FFEE00!important'
                        }
                    }
                }
            },
            MuiPickersDay: {
                day: {
                    borderRadius: '50%!important'
                }
            }
        }
    };
};
